<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes áreas de Povos e Comunidades Tradicionais:

        .list-group
            a.list-group-item.list-group-item-action
                .row
                    label.col-3 Município
                    label.col-3 Área (ha)

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in dados.restricoes'
            )
                .row
                    .col-3
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body'
                        ) {{ restricao.properties.nome_municipio }}

                    .col-3
                        span {{ getArea(restricao) }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoPCT"'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';

import LayerStyle from '@/utils/layerStyles';
import formatters from '@/utils/formatters';

export default {
    name: 'PCT',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        dados: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.dados.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'PCT',
                    tooltip: `Município: ${feature.properties.nome_municipio}`
                };

                this.layersMaps.push(layerRestricao);
            });
        },

        getArea(restricao) {
            return formatters.formatNumber(restricao.properties.areaHa, 2);
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
